




































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { State, Action, namespace } from 'vuex-class'
import { fecthAccountWithCache, Account } from 'ykd-base/account'
import num2Chinese from '@/apps/ice/utils/chinese_num'
import DayPlan, {
  PageDayPlan,
  DayPlanOutline,
  PlanOutline
} from '@/model/plan/dayPlan'
import MyDayPlan from '@/model/plan/myDayPlan'
import Mood from '@/model/plan/mood'
import { queryActionData, QueryActionDataParam } from '@/api/action/action'
import ActionData, { ActionDataType } from '@/model/action/actionData'
import moment from 'moment'
import { saveMyLearn } from '@/api/course/course'
import { MyLearn, Child } from '@/model/course/course'
import genv from 'ykd-base/env'
import YKDClass from '@/model/class/class'
import str2base64 from '@/apps/ice/utils/path'

const ModuleStudyPlan = namespace('app-ice/studyPlan')
const ModuleUser = namespace('app-ice/user')

enum StudyStatus {
  NORMAL = 'NORMAL',
  DELAY = 'DELAY',
  ADVANCE = 'ADVANCE'
}

interface PageOutline {
  courseId: string
  outlineId: string
  outlineIndex: number
  courseName: string
  outlineName: string
}

@Component
export default class TodayTask extends Vue {
  @ModuleStudyPlan.Action('controlAllStudyPlanModal')
  controlAllStudyPlanModal!: Function
  @ModuleStudyPlan.Action('controlShareModal')
  controlShareModal!: Function
  @ModuleStudyPlan.State(state => state.progress)
  progress!: any
  @ModuleStudyPlan.State('punchData')
  punchData!: any
  @ModuleStudyPlan.Action('fetchMyDayPlan')
  private fetchMyDayPlan!: Function
  @ModuleStudyPlan.Action('fetchPunchData')
  fetchPunchData!: Function

  @Prop()
  myDayPlan!: MyDayPlan
  @Prop()
  ykdClass!: YKDClass

  // 解析音频地址
  // url: string = 'https://qgt-style.oss-cn-hangzhou.aliyuncs.com/video/road.mp3'
  // url: string = 'https://qgt-style.oss-cn-hangzhou.aliyuncs.com/video/%E5%AE%A3%E4%BC%A0%E7%89%87_0202.mp4'
  // video 帧
  videoSuffix: string = '?x-oss-process=video/snapshot,t_10000,m_fast'
  // 播放音频
  animateAudioWave: boolean = false
  StudyStatus: any = StudyStatus
  num2Chinese: Function = num2Chinese
  account: any = {}

  async mounted() {
    const account = await fecthAccountWithCache()
    this.account = account

    this.$nextTick(async () => {
      if (this.$refs.resource) {
        this.mediaListener()
      }
    })

    // TODO 定时请求数据
    // 目前采用“用户手动刷新”方案
    // setTimeout(() => {
    //   this.fetchMyDayPlan()
    // }, 180000)
  }

  @Watch('myDayPlan', {
    deep: true
  })
  onChange() {
    if (this.myDayPlan && this.myDayPlan.done) {
      this.fetchPunchData()
    }
  }

  @Watch('$route')
  onRouteChange() {
    this.controlShareModal({
      visible: false,
      url: ''
    })
  }

  showAllStudyPlanModal() {
    this.controlAllStudyPlanModal(true)
  }

  showShareModal() {
    // TODO
    // ? 'http://dev.youkeda.com:1024'
    // ? process.env[`VUE_APP_HOST_development_ham`]
    const domain =
      genv === 'development'
        ? process.env[`VUE_APP_HOST_development_ham`]
        : process.env[`VUE_APP_HOST_production_ham`]
    const url = `${domain}/personal/studyplan/punch_card?type=punch&myDayPlanId=${this.myDayPlan.id}`
    // const url = `http://dev.youkeda.com:1024/personal/studyplan/punch_card?type=punch&myDayPlanId=${this.myDayPlan.id}`
    console.log('url', url)

    this.controlShareModal({
      visible: true,
      url: url
    })
  }

  viewVideo() {
    if (
      this.myDayPlan &&
      this.myDayPlan.dayPlan &&
      this.myDayPlan.dayPlan.url
    ) {
      window.open(this.myDayPlan.dayPlan.url)
    }
  }

  media: any = ''
  mediaDuration: number = 0
  viewResource() {
    const media = this.$refs.resource
    if (media) {
      //@ts-ignore
      media.paused ? media.play() : media.pause()
      this.media = media
    }
  }
  onTimeUpdate() {
    this.mediaDuration = Math.round(this.media.currentTime)
  }

  toLearn() {
    if (this.myDayPlan && !this.myDayPlan.id) {
      // 没有解锁
      this.$message.warning('快去找班主任解锁新的任务吧～')
      return
    }

    if (this.myDayPlan.done) {
      // TODO 继续学习
      const planDay = this.myDayPlan.dayPlan.planDay
      if (moment().isAfter(planDay, 'day')) {
        // 学完的这天任务在今天之前
        // 直接取后一天的任务
        this.fetchMyDayPlan(
          moment(planDay)
            .subtract(-1, 'days')
            .format('YYYY-MM-DD')
        )
      } else {
        // 只给提示
        this.$message.warning('快去找班主任解锁新的任务吧～')
      }
    } else {
      // 去学习
      this.saveMyLearn()
    }
  }

  @ModuleUser.State(state => state.myLearn)
  myLearn!: MyLearn
  @ModuleUser.Action('getMyLearn')
  getMyLearn!: Function
  @ModuleUser.Action('handleMyLearn')
  handleMyLearn!: Function
  private async saveMyLearn() {
    if (!this.dayPlanOutline || this.dayPlanOutline.length === 0) {
      return
    }

    let pageOutline = this.dayPlanOutline[0]
    let outlineUrl = `${pageOutline.outlineIndex}/0/0`
    if (this.myLearn) {
      const course = this.myLearn.courses.find(
        (c: Child) => c.id === pageOutline.courseId
      )
      if (course && course.myCourse && course.myCourse.learnUrl) {
        const outlineIndexArr = this.dayPlanOutline.map((item: PageOutline) => {
          if (item.courseId === course.id) {
            return item.outlineIndex
          }
          return 0
        })
        const max = outlineIndexArr.sort((a: number, b: number) => b - a)[0]

        try {
          const outlineIndex = parseInt(course.myCourse.learnUrl.split('/')[0])
          outlineUrl =
            outlineIndex > max ? outlineUrl : course.myCourse.learnUrl
        } catch (e) {
          console.log(e)
        }
      }
    }
    await saveMyLearn([pageOutline.courseId])
    let learnUrl = `https://ham.youkeda.com/course/${
      pageOutline.courseId
    }/${str2base64(outlineUrl)}`
    window.open(learnUrl)
    await this.getMyLearn()
    this.handleMyLearn()
  }

  get shareDays() {
    return (this.punchData && this.punchData.days) || 0
  }

  get dayPlanOutline() {
    // PageOutline
    const outlines: Array<PageOutline> = []
    const dayPlanOutlines = !this.myDayPlan
      ? []
      : this.myDayPlan.dayPlan
      ? this.myDayPlan.dayPlan.dayPlanOutlines
      : this.myDayPlan.dayPlanOutlines
    if (dayPlanOutlines && dayPlanOutlines.length > 0) {
      dayPlanOutlines.forEach((item: DayPlanOutline) => {
        const courseId = item.courseId
        const courseName = item.name
        item.planOutlines.forEach((o: PlanOutline) => {
          const outline: PageOutline = {
            courseId,
            courseName,
            outlineId: o.outlineId,
            outlineName: o.name,
            outlineIndex: o.index
          }
          outlines.push(outline)
        })
      })
    }
    return outlines
  }

  get avatar() {
    let avatar =
      '//style.youkeda.com/img/ice/default_icon.png?x-oss-process=image/resize,m_mfit,h_150,w_150'
    if (this.account && this.account.user && this.account.user.avatarUrl) {
      avatar = this.account.user.avatarUrl
      if (
        (!avatar && avatar.indexOf('oss-cn-hangzhou.aliyuncs.com') !== -1) ||
        avatar.indexOf('youkeda.com') !== -1
      ) {
        avatar = `${avatar}?x-oss-process=image/resize,m_mfit,h_150,w_150`
      }
    }
    return avatar
  }

  get diff() {
    return this.progress.mine - this.progress.class
  }

  get progressStyle() {
    return {
      class: `width: ${this.progress.class}%;`,
      mine: `width: ${this.progress.mine}%;`
    }
  }

  get studyStatus() {
    let status = StudyStatus.NORMAL
    if (this.diff > 0) {
      status = StudyStatus.ADVANCE
    } else if (this.diff < 0) {
      status = StudyStatus.DELAY
    }
    return status
  }

  get studyStatusText() {
    let text = ''
    const diff = Math.abs(Math.round(this.diff))
    if (this.studyStatus === StudyStatus.DELAY) {
      text = `你已落后班级 <span class="hl">${diff}%</span> 啦！加把劲追上吧！`
    } else if (this.studyStatus === StudyStatus.ADVANCE) {
      text = `你已超越班级 <span class="hl">${diff}%</span> 啦！继续加油吧！`
    }
    return text
  }

  isVideo(url: string) {
    return /(FLV)|(AVI)|(MOV)|(MP4)|(WMV)/i.test(url)
  }

  isSame(dateStr: string) {
    return moment(dateStr).isSame(moment(), 'day')
  }

  mediaListener() {
    ;(this.$refs.resource as HTMLElement).addEventListener(
      'ended',
      (e: any) => {
        this.animateAudioWave = false
      }
    )
    ;(this.$refs.resource as HTMLElement).addEventListener('play', (e: any) => {
      this.animateAudioWave = true
    })
    ;(this.$refs.resource as HTMLElement).addEventListener(
      'pause',
      (e: any) => {
        this.animateAudioWave = false
      }
    )
  }
}
